import { render, staticRenderFns } from "./b-dropdown-multiselect.vue?vue&type=template&id=27421a47&scoped=true"
import script from "./b-dropdown-multiselect.vue?vue&type=script&lang=js"
export * from "./b-dropdown-multiselect.vue?vue&type=script&lang=js"
import style0 from "./b-dropdown-multiselect.vue?vue&type=style&index=0&id=27421a47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27421a47",
  null
  
)

export default component.exports